// THE visibility rule for instance rows, shared by every surface that
// lists them (SessionBrowser's Your Matches / Public Games tabs and
// the header's Queue & Invites panel). One predicate, one answer.
// these views used to apply their own filters over the same server
// data and could disagree about whether a match existed, which is how
// players ended up with zombie rows visible in one panel and absent
// from the other.
//
// A row is visible only if the user can actually do something with it:
//   * terminal (completed / abandoned) rows are noise. The match is
//     decided; the server archive sweeper retires the row for good
//   * host-owned match/sandbox rows whose local save blob is gone
//     can't be resumed, so the save is effectively lost. blobIds is
//     optional. Surfaces that don't track local blobs skip the check.
export function isInstanceRowVisible(inst, profileId, blobIds = null) {
  if (!inst) return false;
  if (inst.phase === 'completed' || inst.phase === 'abandoned') return false;
  const me = (inst.participants || []).find((p) => p.userId === profileId);
  const isHost = me?.role === 'creator';
  const needsLocalBlob = isHost
    && (inst.mode === 'match' || inst.mode === 'sandbox')
    && (inst.phase === 'paused' || inst.phase === 'active');
  if (needsLocalBlob && blobIds && !blobIds.has(inst.id)) return false;
  return true;
}

// Queue & Invites "Active Queues" section: the rows the user is
// actively waiting on. Gathering lobbies always qualify; a paused
// match qualifies for its HOST while resume invitations are still
// outstanding (pending_invite_count comes off the server payload.
// the invitee sees the same wait as a Pending Invite row instead).
export function isActiveQueueRow(inst, profileId) {
  if (!isInstanceRowVisible(inst, profileId)) return false;
  if (inst.phase === 'gathering') return true;
  if (inst.phase === 'paused' && Number(inst.pending_invite_count) > 0) {
    const me = (inst.participants || []).find((p) => p.userId === profileId);
    return me?.role === 'creator';
  }
  return false;
}
